import { css } from "aphrodite";
import styles from "./styles";
import { useSelector } from "react-redux";
import Appointment from "../../../../Models/Appointment/Appointment";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Media } from "../../../../Models";
import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";

const StepDataInfo = ({ appointmentData = null }) => {
    const location = useLocation()
    const selectedService = useSelector(Appointment.getSelectedService);
    const selectedBranch = useSelector(Appointment.getSelectedBranch);
    const dateAndTime = useSelector(Appointment.getSelectedDateAndTime);
    const isAppointmentByBranch = useSelector(Appointment.getIsAppointmentByBranch);
    const branchesData = useSelector(Appointment.getBranchesData);
    const servicesData = useSelector(Appointment.getServicesData);
    const selectedServiceGroupId = useSelector(Appointment.getSelectedServiceGroupId);
    const selectedSubServiceGroupId = useSelector(Appointment.getSelectedSubServiceGroupId);
    const webView = useSelector(Media.getIsWebView);
    const stepItems = useSelector(Appointment.getStepItems);
    const [t] = useTranslation(["translation"]);
    const {i18n} = useTranslation(["translation"]);
    const [currentStepIndex, setCurrentStepIndex] = useState(0);

    const serviceFromGroupIds = Array.isArray(servicesData) && (selectedServiceGroupId || selectedSubServiceGroupId)
        ? servicesData.find(s => 
            (selectedServiceGroupId && s.tags?.ServiceGroupId === selectedServiceGroupId)
          )
        : null;
    
    const serviceToDisplay = selectedService || serviceFromGroupIds;

    useEffect(() => {
        const stepIndex = stepItems.findIndex((step) => step.path === location.pathname);
        setCurrentStepIndex(stepIndex);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    // If appointmentData is provided (cancel/edit pages), show that data instead
    if (appointmentData) {
        const appointmentDate = appointmentData.start ? new Date(appointmentData.start).toLocaleDateString(
            "el-GR",
            { timeZone: "Europe/Athens" }
        ) : null;
        const appointmentTime = appointmentData.start ? new Date(appointmentData.start).toLocaleTimeString(
            "el-GR",
            {
                timeZone: "Europe/Athens",
                hour: "2-digit",
                minute: "2-digit"
            }
        ) : null;

        return (
            <div className={css(styles.container)} style={{ marginTop: '26px' }}>
                {appointmentData.bookingCode && (
                    <div className={css(styles.rowContainer)}>
                        <Typography variant="body1" color="inherit">{t("Reference Number: ")}</Typography>
                        <Typography variant="body1" color="secondary" className={css(styles.textValue)}>&nbsp;{appointmentData.bookingCode}</Typography>
                    </div>
                )}
                {appointmentData.branch && (
                    <div className={css(styles.rowContainer)}>
                        {webView && <Typography variant="body1" color="primary">&nbsp;</Typography>}
                        <Typography variant="body1" color="inherit">{t("Branch: ")}</Typography>
                        <Typography variant="body1" color="secondary" className={css(styles.textValue)}>&nbsp;{appointmentData.branch['name_' + i18n.language]}</Typography>
                    </div>
                )}
                {appointmentDate && (
                    <div className={css(styles.rowContainer)}>
                        {webView && <Typography variant="body1" color="primary">&nbsp;</Typography>}
                        <Typography variant="body1" color="inherit">{t("Date: ")}</Typography>
                        <Typography variant="body1" color="secondary" className={css(styles.textValue)}>&nbsp;{appointmentDate}</Typography>
                    </div>
                )}
                {appointmentTime && (
                    <div className={css(styles.rowContainer)}>
                        {webView && <Typography variant="body1" color="primary">&nbsp;</Typography>}
                        <Typography variant="body1" color="inherit">{t("Time: ")}</Typography>
                        <Typography variant="body1" color="secondary" className={css(styles.textValue)}>&nbsp;{appointmentTime}</Typography>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={css(styles.container, (!selectedService && !selectedBranch && !dateAndTime?.date) && styles.marginEmptyData)}>
            {currentStepIndex >= 1 && (
                <>
                    {isAppointmentByBranch ? (
                        <>
                            {selectedBranch && (
                                <div className={css(styles.rowContainer)}>
                                    <Typography variant="body1" color="inherit">{t("Branch: ")}</Typography>
                                    <Typography variant="body1" color="secondary"  className={css(styles.textValue)}>&nbsp;{selectedBranch['name_' + i18n.language]}</Typography>
                                </div>
                            )}
                            {serviceToDisplay && (
                                <div className={css(styles.rowContainer)}>
                                    {(selectedBranch && webView) && <Typography variant="body1" color="primary">&nbsp;</Typography>}
                                    <Typography variant="body1" color="inherit">{t("Service: ")}</Typography>
                                    <Typography variant="body1" color="secondary" className={css(styles.textValue)}>&nbsp;{serviceToDisplay['name_' + i18n.language]}</Typography>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            {(serviceToDisplay || (!isAppointmentByBranch && Array.isArray(branchesData) && branchesData.length > 0)) && serviceToDisplay && (
                                <div className={css(styles.rowContainer)}>
                                    <Typography variant="body1" color="inherit">{t("Service: ")}</Typography>
                                    <Typography variant="body1" color="secondary" className={css(styles.textValue)}>&nbsp;{serviceToDisplay['name_' + i18n.language]}</Typography>
                                </div>
                            )}
                            {selectedBranch && (
                                <div className={css(styles.rowContainer)}>
                                    {(selectedService && webView) && <Typography variant="body1" color="primary">&nbsp;</Typography>}
                                    <Typography variant="body1" color="inherit">{t("Branch: ")}</Typography>
                                    <Typography variant="body1" color="secondary"  className={css(styles.textValue)}>&nbsp;{selectedBranch['name_' + i18n.language]}</Typography>
                                </div>
                            )}
                        </>
                    )}
                    {dateAndTime?.date && (
                        <div className={css(styles.rowContainer)}>
                            {webView && <Typography variant="body1" color="primary">&nbsp;</Typography>}
                            <Typography variant="body1" color="inherit">{t("Date: ")}</Typography>
                            <Typography variant="body1" color="secondary"  className={css(styles.textValue)} >&nbsp;{dateAndTime.date}</Typography>
                        </div>
                    )}
                    {dateAndTime?.time && (
                        <div className={css(styles.rowContainer)}>
                            {webView && <Typography variant="body1" color="primary">&nbsp;</Typography>}
                            <Typography variant="body1" color="inherit">{t("Time: ")}</Typography>
                            <Typography variant="body1" color="secondary"  className={css(styles.textValue)} >&nbsp;{dateAndTime?.time}</Typography>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default StepDataInfo;
